import ApiConfig from '../config/api'
import BaseAction from './action.abstract'

export default class ShopAction extends BaseAction {
  fetchShelfList(condition?: any): Promise<any> {
    return this.FetchSimpleList(ApiConfig.api.shop.shelf_list, condition)
  }

  fetchShelfMachineList(condition?: any): Promise<any> {
    return this.FetchSimpleList(ApiConfig.api.shop.shelf_machine_list, condition)
  }

  createShelf(formData: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.shop.shelf_create, 'post', formData)
  }

  addShelfMachine(formData: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.shop.shelf_machine_add, 'post', formData)
  }
}

export const shopAction = new ShopAction()
